import React, { ReactElement, ReactNode, InputHTMLAttributes } from "react";
import { HdnKeuzelijstPresentation } from "adviesbox-shared";
import { useHdnData, HdnBerichtSoortType, UseHdnDataResult } from "../../hooks/use-hdn-data";

export type HdnKeuzelijstProps = {
  name: string;
  berichtSoortType: HdnBerichtSoortType;
  keuzelijst: string;
  appendChildren?: ReactNode;
  filter?: string | null;
  readonly?: boolean;
  visible?: boolean;
  fieldSize?: "xl" | "l" | "m" | "s";
  emptyValue?: string;
  hdnData?: UseHdnDataResult;
  useHdnData?: (berichtSoortType: HdnBerichtSoortType, keuzelijst: string) => UseHdnDataResult;
};

const HdnKeuzelijst = ({
  berichtSoortType,
  keuzelijst,
  name,
  appendChildren,
  filter,
  readonly,
  fieldSize,
  emptyValue,
  onChange
}: HdnKeuzelijstProps & InputHTMLAttributes<HTMLSelectElement>): ReactElement | null => {
  const { error, hdnKeuzelijst } = useHdnData(berichtSoortType, keuzelijst);
  let aangepasteOptieLijst: Record<string, string> = hdnKeuzelijst;
  /*istanbul ignore next*/
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  /*istanbul ignore next*/
  if (filter) {
    const options = Object.keys(hdnKeuzelijst).filter(optie => optie.includes(filter));
    if (options.length > 0) {
      aangepasteOptieLijst = {};
      options.forEach(option => (aangepasteOptieLijst[option] = hdnKeuzelijst[option]));
    }
  }

  return (
    <HdnKeuzelijstPresentation
      name={name}
      hdnKeuzelijst={aangepasteOptieLijst}
      appendChildren={appendChildren}
      readonly={readonly}
      fieldSize={fieldSize}
      emptyValue={emptyValue}
      onChange={onChange}
    />
  );
};

HdnKeuzelijst.displayName = "HdnKeuzelijst";

export default HdnKeuzelijst;
